import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { SonaIconComponent } from '@sona/angular-ui-components';
import { ENVIRONMENT } from '@sona/angular-util-environment';
import { HlmSeparatorDirective } from '@spartan-ng/ui-separator-helm';

import { injectFooterItems } from './provide-footer';

@Component({
    selector: 'sona-app-footer',
    imports: [ RouterLink, TranslateModule, HlmSeparatorDirective, SonaIconComponent ],
    templateUrl: './app-footer.component.html',
    styleUrl: './app-footer.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppFooterComponent {
    readonly packageVersion = inject(ENVIRONMENT).version;
    readonly footerItems = injectFooterItems();
}
